import { Component, Input } from '@angular/core';
import { PersonAdresseListEntryMeta } from '../../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { PersonStammMasterDetailEntryMeta, PersonStammVersionDetailEntryMeta } from '../../../../core/personstamm-api';
import { AppPermissionService } from '../../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../../core/base-api';
import { ListLoader } from '../../../../shared/components/list-loader/list-loader';
import { ListLoaderWrapperComponent } from '../../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktPersonenadresseComponent } from '../../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-personstamm-adressen',
  templateUrl: './personstamm-adressen.component.html',
  styleUrls: ['./personstamm-adressen.component.scss'],
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, KompaktPersonenadresseComponent, TranslatePipe]
})
export class PersonstammAdressenComponent {
  @Input() auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
  @Input()
  public entry: PersonStammVersionDetailEntryMeta;
  messages: any = {
    emptyMessage: '',
    selectedMessage: ''
  };

  constructor(
    translate: TranslateService,
    private appPermissionService: AppPermissionService
  ) {
    this.messages.emptyMessage = translate.instant('KeineDatenVorhanden');
  }

  private _listLoader: ListLoader<PersonAdresseListEntryMeta>;

  get listLoader(): ListLoader<PersonAdresseListEntryMeta> {
    return this._listLoader;
  }

  @Input()
  set listLoader(value: ListLoader<PersonAdresseListEntryMeta>) {
    if (!value) {
      return;
    }
    this._listLoader = value;
  }

  hasAnyAdressPermission(): boolean {
    const that = this;
    return [
      PermissionsEnum.ANZEIGE_WOHNADRESSE,
      PermissionsEnum.ANZEIGE_RECHTSDOMIZIL,
      PermissionsEnum.ANZEIGE_ZUSTELLADRESSE,
      PermissionsEnum.ANZEIGE_VERWALTER_ADRESSE,
      PermissionsEnum.ANZEIGE_ANDERE_ADRESSE,
      PermissionsEnum.ANZEIGE_RECHNUNGSADRESSE,
      PermissionsEnum.ANZEIGE_REFERENZADRESSE,
      PermissionsEnum.ANZEIGE_ACI_ADRESSE,
      PermissionsEnum.ANZEIGE_RF_ADRESSE
    ].some(function (p) {
      return that.appPermissionService.hasPermission(p);
    });
  }
}
